import React, { useEffect, useRef, useState } from "react"
import { useDrag } from "react-dnd"
import { T配車, T車輌乗務員 } from "../../../../service/order/haisya/THaisya"
import util from "../../../../ts/util"
import { ItemType } from "../HaisyaRegister"
import { DEFAULT_CARD_CLASS, set配車CardClass } from "../haisyaRegisterUtil"
import CardInfo from "./CardInfo"

const HaisyaTableCard: React.FC<{
  zyomuin: T車輌乗務員
  haisya: T配車[]
  onContextMenuHandler?: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    配車: T配車
  ) => unknown
  date: string
  chip: string
}> = (props) => {
  const [showIndex, setShowIndex] = useState(0)
  const [className, setClassName] = useState(DEFAULT_CARD_CLASS)
  // 設定された配車情報が積日と卸日の中間の配車中であるかのフラグ
  const [is配送中, setIs配送中] = useState(false)

  const [show配車, setShow配車] = useState<T配車>()
  const 配車 = useRef<T配車>()
  const [
    { isDragging },
    dragRef,
    //    dragPreviewRef
  ] = useDrag(
    () => ({
      type: ItemType.配車日単位,
      item: () => ({ 積日: props.date, 受注配車: 配車.current }),
      collect: (c) => ({ isDragging: c.isDragging() }),
    }),
    [props.zyomuin, props.haisya, showIndex]
  )
  const opacity = isDragging ? 0.4 : 1

  const changeIndex: React.MouseEventHandler<HTMLSpanElement> = (_e) => {
    if (showIndex === props.haisya.length - 1) {
      setShowIndex(0)
    } else {
      setShowIndex(showIndex + 1)
    }
  }

  useEffect(() => {
    if (props.haisya.length < showIndex + 1) {
      setShow配車(undefined)
      配車.current = undefined
      setShowIndex(showIndex - 1)
      return
    }
    const new配車情報 = props.haisya[showIndex]
    配車.current = new配車情報
    setShow配車(new配車情報)
    const [addClassName, 配送中フラグ] = set配車CardClass(
      props.zyomuin,
      new配車情報,
      props.date
    )
    setIs配送中(配送中フラグ)
    setClassName(
      util.addTextWithStartDelimiter(DEFAULT_CARD_CLASS, addClassName)
    )
  }, [props.zyomuin, props.haisya, showIndex, props.date])

  return (
    <>
      <div
        ref={dragRef}
        className={className}
        onContextMenu={(e) => {
          if (show配車 == null) return
          e.preventDefault()
          e.stopPropagation()
          props.onContextMenuHandler && props.onContextMenuHandler(e, show配車)
        }}
        style={{
          opacity,
          cursor: isDragging ? "grabbing" : "grab",
        }}>
        {show配車 && (
          <CardInfo
            車輌乗務員={props.zyomuin}
            cardInfo={show配車}
            haisoTyuFlg={is配送中}
            chip={props.chip}>
            {props.haisya.length > 1 && (
              <div
                className="text-end w-100"
                style={{ visibility: isDragging ? "hidden" : "visible" }}>
                <span
                  className="fw-bold text-decoration-underline "
                  onClick={changeIndex}
                  style={{ cursor: "pointer" }}>
                  {showIndex + 1}/{props.haisya.length}
                </span>
                件
              </div>
            )}
          </CardInfo>
        )}
      </div>
    </>
  )
}
export default HaisyaTableCard
